import React from 'react';
import cx from 'classnames';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Link from '../Link';
import NextLink from 'next/link';

const useStyles = makeStyles(theme => ({
  root: {
    height: 216,
  },
  bar: {
    display: 'flex',
    height: '50%',
    justifyContent: 'center',
    backgroundColor: props =>
      props.dark ? theme.palette.sketch.grey3 : 'transparent',
  },
  top: {},
  bottom: {
    borderTop: `1px solid ${theme.palette.common.white}`,
    backgroundColor: `${theme.palette.sketch.grey3} !important`,
    alignItems: 'center',
    flexDirection: 'column',
  },
  links: {
    diplay: 'flex',
    alignItems: 'center',
    '& > *': {
      alignItems: 'center',
      display: 'inline-flex',
      '&:after': {
        margin: theme.spacing(0, 1),
        display: 'inline-flex',
        content: '""',
        height: '1em',
        width: 1,
        backgroundColor: theme.palette.primary.main,
      },
      '&:last-child': {
        '&:after': {
          display: 'none',
        },
      },
    },
  },
  logos: {
    padding: theme.spacing(2),
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    height: props => props.height || '80%',
    width: 'auto',
    margin: theme.spacing(0, 2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, 1),
      height: props => props.height || '70%',
    },
  },
}));

const Logo = ({ href, ...props }) => {
  const classes = useStyles(props);
  if (!href) {
    return <Box className={classes.logo} component="img" {...props} />;
  }
  return (
    <Box
      component="a"
      className={classes.logo}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Box component="img" width="auto" height="100%" {...props} />
    </Box>
  );
};

// const externalLinks = {
//   production:
// }

const Footer = props => {
  const { context } = props;
  const classes = useStyles(props);
  const linkContext =
    process.env.NODE_ENV === 'production' ? '/' : `/enplus/${context}/`;
  return (
    <footer className={classes.root}>
      <Box
        height={8 * 14}
        bgcolor={props.dark ? 'sketch.grey3' : 'common.white'}
      />
      <Hidden mdUp>
        <Box
          display="flex"
          justifyContent="center"
          bgcolor={props.dark ? 'sketch.grey3' : 'common.white'}
        >
          <Logo
            href="https://depi.de"
            src="/images/DEPI_Logo.svg"
            height={50}
          />
        </Box>
      </Hidden>
      <div className={cx(classes.bar, classes.logos)}>
        <Hidden smDown>
          <Logo
            href="https://depi.de"
            src="/images/DEPI_Logo.svg"
            height="70%"
          />
        </Hidden>
        <Logo
          href="https://enplus-hackschnitzel.de"
          src="/images/ENplus_Logo_Hackschnitzel.svg"
        />
        <Logo
          href="https://enplus-briketts.de"
          src="/images/ENplus_Logo_Holzbriketts.svg"
        />
        <Logo href="https://enplus-pellets.de" src="/images/ENplus_Logo.svg" />
        <Logo
          href="https://depi.de/pelletfachbetriebe-und-ofenstudios"
          src="/images/Logo_Fachstudio.svg"
        />
        <Logo
          href="https://depi.de/pelletfachbetriebe-und-ofenstudios"
          src="/images/Logo_Pelletfachbetrieb.svg"
        />
      </div>
      <div className={cx(classes.bar, classes.bottom)}>
        <div className={classes.links}>
          <Link variant="h6" color="primary" href={`${linkContext}kontakt`}>
            Kontakt
          </Link>
          <Link
            variant="h6"
            color="primary"
            href={`${linkContext}[...pageId]`}
            as={`${linkContext}impressum`}
          >
            Impressum
          </Link>
          <Link
            variant="h6"
            color="primary"
            href={`${linkContext}[...pageId]`}
            as={`${linkContext}datenschutz`}
          >
            Datenschutz
          </Link>
        </div>
        <div className={classes.Copyright}>
          <Typography variant="caption" color="textSecondary">
            <b>
              Copyright © 2008-{new Date().getFullYear()} DEPI. Alle Rechte
              vorbehalten.
            </b>
          </Typography>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
